import { render, staticRenderFns } from "./NumericType.vue?vue&type=template&id=79bde8be&"
import script from "./NumericType.vue?vue&type=script&lang=ts&"
export * from "./NumericType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports